import React, { useEffect, useState } from "react";

import {
  Transaction_Campaign,
  Transaction_Card,
  Transaction_Payment,
} from "../../Connections/Transaction";

import Page from "./Page";
import BookSlider from "../../Components/Common/BookSlider";
import PenText from "../../Components/Common/PenText";
import Toast from "../../Utils/Toast";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import Ravi from "../../Components/Common/Ravi";
import AddHomePage from "../../Components/Common/AddHomePage";
import "../../Styles/Home.css";
import { useNavigate } from "react-router";
import DiscountCard from "../../Components/Common/discountCard";

const Home = (props) => {
  const navigator = useNavigate();

  // ==========================================================

  const [books, setBooks] = useState([]);
  const [help, setHelp] = useState();

  // ==========================================================

  const handleBuyAllBooks = () => {
    const PostedData = { campaignId: 3 };
    if (localStorage.getItem("Token")) {
      // navigator("/cart");
      Transaction_Card.AddCart(PostedData)
        .then((res) => {
          if (res[0]) {
            navigator("/cart");
          } else {
            console.log("Error");
            Toast("error", res[1]);
          }
        })
        .catch((err) => console.log("err " + err));
    } else {
      navigator("/login");
    }
  };

  // ==========================================================

  const dataLayer = window.dataLayer;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const Authority = urlParams.get("Authority");
    const Status = urlParams.get("Status");
    if (Authority != null && Status != "Ok") {
      Transaction_Payment.VerifyPayment(Authority).then((res) => {
        if (res[0]) {
          Toast("success", "خرید با موفقیت انجام شد");
          Transaction_Payment.GetLastPayment()
            .then((res) => {
              if (res[0]) {
                res[2].data?.books?.map((item) => {
                  let bookLayerValue = {
                    bookCategory: item.title,
                    bookTitle: item.description,
                    bookId: item.id,
                    bookPrice: item.price,
                    paid: true,
                  };
                  dataLayer.push(bookLayerValue);
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          Toast("error", "خرید شما ناموفق بوده است");
        }
      });
    }

    Transaction_Campaign.GetOneCampaign(3).then((res) => {
      if (res[0]) {
        setBooks(res[2].data.books);
        setHelp(res[2].data.helps[0]);
      }
    });
  }, []);

  // ==========================================================

  return (
    <Page>
      <div className="Home_wrapper">
        <MobileNavBar text="پویش" action={() => navigator("/hisstori")} />
        <div className="Home_one">
          <div className="Home_one-right">
            <img
              className="Home_one-right-image"
              src="/imgs/Landing/Landing-first-section-banner.svg"
              alt=""
            />
            <div className="Home_one-right-item-svg">
              <img
                className="Home_one-right-svg"
                src="/imgs/Landing/logo.svg"
                alt=""
              />
            </div>
          </div>
          <div className="Home_one-left">
            <PenText text={help} />
          </div>
        </div>
        <div className="Home_two">
          <BookSlider
            slides={books}
            isLink={true}
            style={{ height: 215 }}
            breakPoint={{
              1594: {
                slidesPerView: 8,
              },
              1496: {
                slidesPerView: 7,
              },
              1428: {
                slidesPerView: 6,
              },
              1248: {
                slidesPerView: 5,
              },
              1000: {
                slidesPerView: 4,
              },
              842: {
                slidesPerView: 3,
              },
              600: {
                slidesPerView: 2,
              },
            }}
          />
        </div>
        <div className="Home_Three">
          {/* <img
            className="Home_Three-image"
            src="/imgs/Home/right.svg"
            alt="buy all"
            onClick={() => handleBuyAllBooks()}
            style={{ cursor: "pointer" }}
          /> */}
          {/* electronic book */}
          <div className="Home_Three_Box_parent">
            <DiscountCard>
              <div
                onClick={() => handleBuyAllBooks()}
                className="Home_Three_Box"
                style={{ backgroundColor: "#1A1E7E" }}
              >
                <div className="Home_Three_Right_Parent">
                  <p className="Home_Three_Title">
                    ۱۵ کتاب الکترونیک رو با تـخـفیف ویژه بخــــر!
                  </p>
                  <div className="Home_Three_Prices">
                    <p className="price">۷۹,500 تومـــــان</p>
                    <div className="discount_price">
                      <span className="badge">٪76</span>
                      <p>۳۳۰,000 تومان</p>
                    </div>
                    <div className="Home_Three_Score">
                      <img
                        src="/imgs/bashgah/bashgah-group.svg"
                        alt="scorePic"
                      />
                      <p>بـا ۴۰۰۰ امتیـــاز</p>
                    </div>
                  </div>
                </div>
                <img
                  className="Home_Three_Banner"
                  src="/imgs/Home/electric-book.svg"
                  alt="bookPic"
                />
              </div>
            </DiscountCard>
          </div>
          {/* fizical book */}
          <div className="Home_Three_Box_parent">
            <DiscountCard>
              <div
                onClick={() => {
                  window.open(
                    "http://store.ketabhayekhoob.ir/product/sarghozesht/?ref=aghigh",
                    "_blank"
                  );
                }}
                className="Home_Three_Box"
                style={{ backgroundColor: "#061A55" }}
              >
                <div className="Home_Three_Right_Parent">
                  <p className="Home_Three_Title">
                    ۱۵ جلد کتاب چاپی رو با تـخـفیف ویژه بخـــــر!
                  </p>
                  <div className="Home_Three_Prices">
                    <p className="price">787,500 تومـــــان</p>
                    <div className="discount_price">
                      <span className="badge">٪۱۱</span>
                      <p>875,000</p>
                    </div>
                    <div className="Home_Three_Score">
                      <img
                        src="/imgs/bashgah/bashgah-group.svg"
                        alt="scorePic"
                      />
                      <p>بـا ۴۰۰۰ امتیـــاز</p>
                    </div>
                  </div>
                </div>
                <img
                  className="Home_Three_Banner"
                  src="/imgs/Home/physical-book.svg"
                  alt="bookPic"
                />
              </div>
            </DiscountCard>
          </div>
          {/* <img
            className="Home_Three-image2 mobile-hidden"
            src="/imgs/Home/left.svg"
            alt="Hisstori.ir"
            onClick={() => navigator("/hisstori")}
          /> */}
        </div>
        {/* <Penhelp setHelpText={setHelpText} /> */}
        <Ravi text={help} />
      </div>
    </Page>
  );
};

export default Home;
